import { Modal } from 'antd';
import React from 'react';
import styles from '../../../Style/DatasetInfo.module.scss';

export const TNSWarningModal = ({
  visible,
  onClose,
}: {
  visible: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal open={visible} footer={null} onOk={onClose} onCancel={onClose}>
      <div className={styles.modal}>
        <div>This dataset is not yet approved by RVO and certified.</div>
        Use at your own risk.
        <div></div>
      </div>
    </Modal>
  );
};
